export default "__VITE_ASSET__CjeKl3E$__"